import { useRef, useState } from "react";
import axios from "../../../../axios";

// Multi-photo uploader. `value` is an array of image URLs; onChange(newArray).
// Upload several photos — the public site auto-rotates through them.
export default function ImagesInput({ value = [], onChange, onError }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setUploading(true);
    const uploaded = [];
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("image", file);
        const { data } = await axios.post("/upload", fd);
        uploaded.push(data.url);
      } catch (err) {
        console.warn(err);
        onError?.();
      }
    }
    setUploading(false);
    if (uploaded.length) onChange([...value, ...uploaded]);
    // reset so the same file can be picked again
    if (inputRef.current) inputRef.current.value = "";
  };

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= value.length) return;
    const next = [...value];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <div className="block text-sm font-medium text-neutral-700">
          Фотографии {value.length > 0 ? `(${value.length})` : ""}
        </div>
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-500"
        >
          {uploading ? "Загрузка..." : "Добавить фото"}
        </button>
      </div>
      <p className="text-sm text-neutral-500 mb-3">
        Можно выбрать сразу несколько. Первое фото — обложка. Стрелками меняй порядок.
      </p>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleFiles}
        hidden
      />
      {value.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {value.map((url, i) => (
            <div
              key={`${url}-${i}`}
              className="relative group rounded-lg overflow-hidden border border-neutral-200 bg-neutral-100"
            >
              <img
                src={`${process.env.REACT_APP_BASE_API}${url}`}
                alt=""
                className="w-full h-28 object-cover"
              />
              {i === 0 && (
                <span className="absolute top-1 left-1 rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-semibold text-white">
                  Обложка
                </span>
              )}
              <button
                type="button"
                onClick={() => removeAt(i)}
                className="absolute top-1 right-1 h-6 w-6 rounded-full bg-red-600 text-white text-sm leading-none flex items-center justify-center hover:bg-red-500"
                aria-label="Удалить"
              >
                ×
              </button>
              <div className="absolute bottom-1 right-1 flex gap-1">
                <button
                  type="button"
                  onClick={() => move(i, -1)}
                  className="h-6 w-6 rounded bg-black/60 text-white text-xs hover:bg-black/80"
                  aria-label="Влево"
                >
                  ‹
                </button>
                <button
                  type="button"
                  onClick={() => move(i, 1)}
                  className="h-6 w-6 rounded bg-black/60 text-white text-xs hover:bg-black/80"
                  aria-label="Вправо"
                >
                  ›
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-sm text-neutral-400 border border-dashed border-neutral-300 rounded-lg py-6 text-center">
          Фото пока не добавлены
        </div>
      )}
    </div>
  );
}
